/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'

import swipelyticsSpinnerGIF from '../../assets/swipelytics-spinner-4.gif'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { standardSpinner } from '../../helpers/spinners'
import useWindowDimensions from '../../helpers/windowDimensions'
import { seoPageTags, customAnalyticsEvent, runGTAGScript } from '../../helpers/analytics'
import { isInstagramOrFacebook } from '../../helpers/globalHelpers.js'

import { navbarHeight, footerHeight, oneTimeRate } from '../../helpers/variableDefaults.js'

import AllAuth from '../auth/AllAuth.js'


// Create Account Master Page
const CreateAccount = (props) => {
  // console.log('create account runs')

  // const {  } = props

  // useEffect(() => {
  // }, [])
  
  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {
        // !isInstagramOrFacebook() ?
        seoPageTags(
          'Create Account'
        )
        // :
        // runGTAGScript()
      }

      {/* Body */}
      <Box 
        sx={{ 
          minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
          width: '100vw', 
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
        }}
      >

        <AllAuth fromCreateAccount={true} />
        
      </Box>
    </>
  )
  
}

export default CreateAccount
